var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9523 16.1101L14.0558 12.2136C13.5666 12.9395 12.9406 13.5658 12.2144 14.0551L16.1108 17.9516C16.6193 18.46 17.4438 18.46 17.9523 17.9516C18.4601 17.4447 18.4601 16.6179 17.9523 16.1101Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66675 8.43758C1.66675 4.69832 4.698 1.66675 8.40829 1.66675C12.1778 1.66675 15.1791 4.69832 15.1791 8.43758C15.1791 12.1768 12.1186 15.2084 8.40829 15.2084C4.698 15.2084 1.66675 12.1768 1.66675 8.43758ZM4.24175 8.43758C4.24175 10.7351 6.11089 12.6042 8.40842 12.6042C10.7359 12.6042 12.5751 10.7358 12.5751 8.43758C12.5751 6.14005 10.7059 4.27091 8.40842 4.27091C6.11089 4.27091 4.24175 6.14005 4.24175 8.43758Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1e345cd31a9c9fef75d2b0959a156d33.svg";
export { ForwardRef as ReactComponent };